import * as React from 'react';

import styles from './styles.module.scss';

function MaterialEntriesLoading() {
	return (
		<>
			<div className={styles.MaterialEntryLoading} />
			<div className={styles.MaterialEntryLoading} />
			<div className={styles.MaterialEntryLoading} />
			<div className={styles.MaterialEntryLoading} />
			<div className={styles.MaterialEntryLoading} />
			<div className={styles.MaterialEntryLoading} />
			<div className={styles.MaterialEntryLoading} />
			<div className={styles.MaterialEntryLoading} />
			<div className={styles.MaterialEntryLoading} />
			<div className={styles.MaterialEntryLoading} />
			<div className={styles.MaterialEntryLoading} />
		</>
	);
}

export default React.memo(MaterialEntriesLoading);
